import { createLogger } from 'redux-logger';
import navMiddleware from './navMiddleware';
import browserCheckMiddleware from './browserMiddleware';
import cameraCheckMiddleware from './cameraMiddleware';
import microphoneCheckMiddleware from './microphoneMiddleware';
import speakersCheckMiddleware from './speakersMiddleware';
import connectivityCheckMiddleware from './connectivityMiddleware';

export const createMiddlewares = ({ verbose, checkList }) => getDefaultMiddleware => {
  const checkMiddlewareMap = {
    browser: browserCheckMiddleware,
    camera: cameraCheckMiddleware,
    microphone: microphoneCheckMiddleware,
    speakers: speakersCheckMiddleware,
    connectivity: connectivityCheckMiddleware,
  };
  const middlewares = [
    ...getDefaultMiddleware({ thunk: false }),
    navMiddleware,
  ];
  Object.entries(checkMiddlewareMap).forEach(([checkLabel, checkMiddleware]) => {
    if (checkList.includes(checkLabel)) {
      middlewares.push(checkMiddleware);
    }
  });
  if (verbose) {
    middlewares.push(createLogger({
      diff: true,
      collapsed: true,
    }));
  }
  return middlewares;
};
